import React from "react";
import FlexBox from "../../../../FlexBox/FlexBox";
import { IInnovationMargauxMotinProduct } from "../../InnovationMargauxMotin/InnovationMargauxMotin";
import Typography from "../../../../../Foundation/Typography/Typography";
import { _InnovationProductMargauxMotinRoot } from "./InnovationProductMargauxMotin.styled";
import clsx from "clsx";
import Button from "../../../../../Foundation/Button/Button";
import useBreakpoint from "../../../../Grid/hooks/useBreakpoint";
import { innovationProductMargauxMotinConfig } from "./InnovationProductMargauxMotin.config";

export interface IInnovationProductMargauxMotinProps<T extends any = any> {
  product: IInnovationMargauxMotinProduct<T>;
  className?: string;
  onClick?: (product: IInnovationMargauxMotinProduct) => void;
  showLessLabel: string;
  showMoreLabel: string;
  ctaLabel?: string;
  hideCta?: boolean;
  selectiveView?: "image" | "text";
  index?: number;
}

const InnovationProductMargauxMotin = <T extends any = any>(
  props: IInnovationProductMargauxMotinProps<T>
) => {
  const { product, className, onClick, ctaLabel: _ctaLabel, hideCta: hideCtaProp, index } = props;
  const { mobile } = useBreakpoint();

  const ctaLabel = _ctaLabel || product.ctaLabel || "Je commande";
  const hideCta =
    hideCtaProp === true ||
    Boolean((product as { hideCta?: boolean }).hideCta);
  const config = innovationProductMargauxMotinConfig[index || 0 % 3];
  const bgSvg = config.bgSvg(product.color || config.color);

  return (
    <_InnovationProductMargauxMotinRoot
      direction="column"
      gap={12}
      className={clsx(className, { "action-on-hover": !mobile })}
    >
      {/* Background SVG that can cross the edge */}
      {bgSvg}

      {config.renderTopImage && config.renderTopImage()}

      <FlexBox
        className="innovation-product-margaux-motin-content"
        direction="column"
        gap={8}
        style={{
          height: "100%",
          maxWidth: config.maxWidth,
          width: "100%",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Typography variant={"margaux2-xs"} style={config.titleStyle}>
          {product.title}
        </Typography>
        {<Typography variant="body2">{product.description}</Typography>}

        {((product.displayPrice && product.price) || product.priceSubtitle) && (
          <FlexBox
            direction="column"
            style={{ marginTop: "auto" }}
            gap={0}
            wrap={"wrap"}
          >
            {product.displayFromMention && product.price && (
              <Typography
                variant="ui4"
                style={{
                  marginTop: 8,
                }}
              >
                {product.displayFromMention}
              </Typography>
            )}
            {product.price || product.priceSubtitle ? (
              <FlexBox
                style={{ height: 20, marginTop: "auto" }}
                gap={8}
                align="center"
                wrap={"wrap"}
              >
                {product.price && (
                  <Typography
                    variant={"subtitle3"}
                    style={{ fontWeight: "bold" }}
                  >
                    {product.price}
                  </Typography>
                )}
                {product.priceSubtitle && product.price && <span>|</span>}
                {product.priceSubtitle && (
                  <Typography className="dot-separator" variant="body2">
                    {product.priceSubtitle}
                  </Typography>
                )}
              </FlexBox>
            ) : null}
          </FlexBox>
        )}

        {!hideCta && (
          <div>
            <Button
              className={clsx("innovation-product-action-button")}
              onClick={() => onClick?.(product)}
            >
              {ctaLabel}
            </Button>
          </div>
        )}
      </FlexBox>
      {config.renderBottomImage && config.renderBottomImage()}
    </_InnovationProductMargauxMotinRoot>
  );
};

export default InnovationProductMargauxMotin;
